<template>
  <div class="second-body">
    <div id="content">
      <div class="container">
        <div class="col-md-12">
          <div class="de_tab tab_style_2">
            <ul class="de_nav">
              <li
                :class="`${index == currentTab ? 'active' : ''}`"
                v-for="(section, index) in listSections"
                @click="selected = index"
                :key="`${index}_index_section`"
              >
                <span v-text="section.title">{{ section.title }}</span>
                <div class="v-border"></div>
              </li>
            </ul>

            <div class="de_tab_content">
              <div class="row">
                <template
                  v-for="(subsection, indexSubCategorie) in listSections[
                    selected
                  ].sub_sections"
                >
                  <div
                    class="subsection subsection_second"
                    :key="
                      `section_${subsection._id}_sub_section_${indexSubCategorie}`
                    "
                    @click="
                      sub_selected = indexSubCategorie;
                      collapsedArray(indexSubCategorie, selected);
                    "
                    v-if="showSub(subsection)"
                  >
                    <span
                      v-text="
                        subsection.title == 'null-sub-sections'
                          ? ''
                          : subsection.title
                      "
                      >{{ subsection.title }}</span
                    >
                  </div>
                  <div
                    class="col-md-6 mb30 item_sub my_item_"
                    v-for="(item, indiceItem) in subsection.items"
                    @click.exact="
                      (e) => {
                        addToCart(item, e);
                      }
                    "
                    :key="`${indexSubCategorie}_${indiceItem}_mwnu_items`"
                  >
                    <div
                      class="post-menu"
                      v-if="
                        showSub(subsection) &&
                          vIfcollapsed(indexSubCategorie, selected)
                      "
                    >
                      <img
                        :src="
                          `${
                            item.image
                              ? 'htttp://localhost:3333/uploads/menu-items/' +
                                item.image
                              : 'htttp://localhost:3333/assets/img/balloon.jpg'
                          }`
                        "
                        class="img-responsive"
                        alt=""
                      />
                      <div
                        class="sub-item-service meta  "
                        :ref="`my_item_${item._id}`"
                      >
                        <div class="infos_second">
                          <div
                            class="c1 menu_item_title_custom"
                            v-text="item.title"
                          >
                            {{ item.title }}
                          </div>
                          <div class="c2"></div>
                          <div class="c3">
                            <span v-text="item.price">
                              {{ item.price }}
                            </span>
                            <span>
                              {{ currentCurrency.symbol }}
                            </span>
                          </div>
                        </div>
                        <p
                          class="service-text meta-content p-custom"
                          v-text="item.observation"
                        >
                          {{ item.observation }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlideComponent from "../plugins/GlideComponent.vue";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
    "glide-component": GlideComponent,
  },
  props: [
    "classic",
    "smaler",
    "newItem",
    "newSection",
    "listSections",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "currentCurrency",
    "addToCart",
  ],
  data() {
    return {
      collapsedArrayVar: [],
      glideBasicOption: {
        gap: 5,
        perView: 3,
        type: "carousel",
        hideNav: true,
        breakpoints: {
          600: {
            perView: 1,
          },
          1400: {
            perView: 2,
          },
        },
      },
      apiPath1: "",
      selected: 0,
      sub_selected: 0,
    };
  },
  watch: {
    selected(newval) {
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    vIfcollapsed(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;
      let item = this.collapsedArrayVar.find((item) => item == searchedIndice);
      if (item) {
        return true;
      } else {
        return false;
      }
    },
    collapsedArray(indexSubCategorie, indexSection) {
      let searchedIndice = indexSection + "_" + indexSubCategorie;

      if (this.collapsedArrayVar.includes(searchedIndice)) {
        this.collapsedArrayVar.splice(
          this.collapsedArrayVar.indexOf(searchedIndice),
          1
        );
      } else {
        this.collapsedArrayVar.push(searchedIndice);
      }
    },
    collapsed(index, selected) {
      this.functionCollapsed(index, selected);
      // this.$emit("functionCollapsed", index, selected);
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      // console.log(this.newItem[0].sections);
      // console.log(subSection);
      // console.log(this.listSections[this.selected].show_subCategories);
      if (this.listSections[this.selected].show_subCategories == undefined) {
        return true;
      }
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style>
.service-text.meta-content.p-custom {
  text-align: left;
}
.c1.menu_item_title_custom {
  font-weight: bold;
}
#content {
  width: 100%;
  background: #fff;
  padding: 90px 0 90px 0;
  z-index: 100;
}

#content {
  background: #fff;
}

.de_tab .de_nav {
  overflow: hidden;
  padding-left: 0;
  margin: 0;
  padding: 0;
  font-weight: bold;
}

.de_tab .de_nav li span {
  padding: 8px 16px 8px 16px;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  display: block;
  background: #f5f5f5;
  text-decoration: none;
  color: #646464;
  font-size: 13px;
  cursor: pointer;
}

.de_tab.tab_steps .de_nav {
  text-align: center;
}
.de_tab.tab_steps .de_nav li {
  background: none;
  display: inline-block;
  float: none;
  margin: 0 20px 0px 20px;
}

.de_tab.tab_steps .de_nav li span {
  padding: 30px 0 30px 0;
  border-radius: 120px;
  color: #222;
  font-family: "Montserrat";
  font-size: 16px;
  -moz-border-radius: 120px;
  -webkit-border-radius: 120px;
  line-height: 20px;
  width: 180px;
  height: 180px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.de_tab.tab_steps.style-2 .de_nav li span {
  background: rgba(23, 30, 40, 0.8);
  border-radius: 0px;
  border: solid 2px rgba(255, 255, 255, 0);
  font-size: 17px;
  color: #fff;
}

.de_tab.tab_steps.style-2 .de_nav li.active span {
  border: solid 2px rgba(255, 255, 255, 0.8);
  color: #222;
  border-color: olivedrab;
}

.de_tab.tab_steps .de_nav li span:hover {
  background: none;
  border: solid 2px rgba(255, 255, 255, 0.2);
  color: #fff;
}

.de_tab.tab_steps .de_nav li .v-border {
  height: 60px;
  border-left: solid 1px rgba(255, 255, 255, 0.3);
  display: inline-block;
  margin-bottom: -5px;
}

.de_tab.tab_steps.dark .de_nav li .v-border {
  border-left: solid 1px rgba(0, 0, 0, 0.3);
}

.de_tab .de_nav li span {
  border: none;
  background: #222;
}

.de_tab .de_nav li:first-child span {
  border-left: 1px solid #ddd;
}

.de_tab .de_nav li:first-child span {
  border-left: 1px solid #404040;
}

.de_tab .de_tab_content {
  border: 1px solid #ddd;
  padding: 15px 20px 20px 20px;
  margin-top: -1px;
  background: #fff;
}

.de_tab .de_tab_content {
  border: 1px solid #404040;
  background: #27282b;
}

.de_tab.tab_steps .de_tab_content {
  background: 0;
  padding: 0;
  border: none;
  padding-top: 30px;
  border-top: solid 1px rgba(255, 255, 255, 0.4);
}

.de_tab.tab_steps.dark .de_tab_content {
  border-top: solid 1px rgba(0, 0, 0, 0.4);
}

.de_tab .de_nav li.active span {
  background: #fff;
  border-bottom: 1px solid #fff;
  color: #222;
  margin-bottom: -3px;
}

.de_tab .de_nav li.active span .v-border {
  display: none !important;
}

.de_tab .de_nav li.active span {
  background: #27282b;
  border-bottom: 1px solid #27282b;
  color: #ccc;
}

.de_tab.tab_steps .de_nav li.active span {
  background: none;
  color: #ffffff;
  border: solid 2px rgba(255, 255, 255, 0.8);
}

.de_tab.tab_steps.dark .de_nav li.active span {
  background: none;
  color: #333;
  border: solid 1px rgba(0, 0, 0, 0.8);
}

/* new added */
.de_tab.tab_steps.tab_6 .de_nav li span {
  padding: 20px 0 20px 0;
  font-size: 14px;
  line-height: 70px;
  width: 120px;
  height: 120px;
}

.de_tab.tab_style_2 .de_nav {
  background: #111;
  text-align: center;
}

.de_tab.tab_style_2 .de_nav li {
  margin: 0;
  border: none;
}
.de_tab.tab_style_2 .de_nav li span {
  font-family: "Montserrat";
  padding: 10px 30px 10px 30px;
  background: #333;
  color: #fff;
  border: none;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-size: 13px !important;
}

.de_tab.tab_style_2 .de_tab_content {
  border: none;
}
.de_tab.tab_style_2 .de_tab_content {
  border: none;
}
.de_tab.tab_style_2.no-bg-content .de_tab_content {
  background: none !important;
  border-color: #111 !important;
}
.de_tab .de_tab_content.tc_style-1 {
  background: none;
  padding: 0;
  padding-top: 30px;
}

/* tab */
.de_tab.tab_style_2 .de_tab_content {
  border: none;
  background: rgba(255, 255, 255, 0.9);
  padding: 40px;
  padding-bottom: 20px;
  border: solid 2px #333;
  border-top: none;
}

.de_tab.tab_style_2 .de_nav li {
  float: none;
  list-style: none;
  background: none;
  margin: 0 5px 0 5px;
  text-align: center;
  display: inline-block;
}

.de_tab.tab_style_2 .de_nav li img {
  width: auto;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.7;
}

.de_tab.tab_style_2 .de_nav li.active img {
  width: auto;
  -webkit-filter: grayscale(0%);
  -moz-filter: grayscale(0%);
  -o-filter: grayscale(0%);
  -ms-filter: grayscale(0%);
  filter: grayscale(0%);
  opacity: 1;
}

.de_tab.tab_style_2 .de_nav li span {
  background: none;
  display: block;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  border: none;
}

.de_tab.tab_style_2 .de_nav li.active span {
  border-bottom: solid 6px #ca8e46;
  color: white;
  background: none;
}

.de_tab.timeline.nav_4 li {
  display: inline-block;
  text-align: center;
  background: none;
  width: 24%;
}

.de_tab.timeline.nav_4 li span {
  background: none;
  border: none;
  margin-top: 20px;
  font-family: "Montserrat";
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.de_tab.timeline.nav_4 .dot {
  display: block;
  width: 8px;
  height: 8px;
  background: #fff;
  opacity: 1;
  margin: 0 auto;
  border-radius: 8px;
  margin-top: 1px;
}

.de_tab.timeline.nav_4 .dot:before,
.de_tab.timeline.nav_4 .dot:after {
  content: "";
  position: absolute;
  height: 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  top: 0;
  width: 24%;
}

.de_tab.timeline.nav_4 li:last-child .dot:before,
.de_tab.timeline.nav_4 li:last-child .dot:after {
  border-bottom: none;
}

.de_tab.timeline li .num {
  font-size: 20px;
}

.de_tab.timeline .de_tab_content {
  background: none;
  border: none;
  padding-top: 30px;
}

.de_tab .navigation_arrow {
  text-align: center;
}

.subsection.subsection_second {
  display: flex;
  justify-content: space-between;
  background: #eeeeee;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 5px;
  color: #263238;
  align-items: center;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
}
.subsection.subsection_second span {
}
.subsection.subsection_second img {
  width: 12px;
  height: 12px;
  filter: contrast(0.5);
}

.post-menu img {
  width: 90px;
  /* height: auto; */
  /* position: absolute; */
  /* margin-top: 8px; */
  border-radius: 3px;
}
.meta,
.post-menu {
  padding-left: 10px;
}
.post-menu.s1 img {
  width: 100%;
  height: auto;
  border-radius: 0;
  position: static;
}
.post-menu.s1 .meta,
.post-menu.s1 .meta-content {
  padding: 0;
}
.post-menu.s1 .c1 {
  margin-top: 10px;
}
.post-menu.s1 .c1,
.post-menu.s1 .c3 {
  display: block;
}

.post-menu-view .price {
  font-family: "Montserrat";
  font-size: 24px;
  padding: 10px 16px 10px 16px;
  color: #fff;
  display: inline-block;
  margin-right: 2px;
  float: left;
}
.post-menu-view .dish {
  font-family: "Montserrat";
  font-size: 18px;
  padding: 10px 16px 10px 16px;
  background: #eee;
  display: inline-block;
  margin-right: 2px;
  float: left;
}
.sub-item-service.meta {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  color: black;
  cursor: pointer;
}
.post-menu {
  margin-top: 1em;
  margin-bottom: 1em;
  padding-left: 0px !important;
  display: flex;
}
.infos_second {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.new_category_second {
  cursor: pointer;
  padding: 1em;
  text-align: center;
  background: white;
  border: 1px solid black;
  font-size: 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: black;
}
.new_category_second:hover {
  background: black;
  color: white;
}
.mange_category {
  box-shadow: 1px 1px 4px 1px #d8d8d8;
}
.mange_category_second {
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  /* margin: 0 11px; */
}
#ddown1_second {
  flex: 1;
  border: 1px solid gray;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 6px 12px;
  margin-right: 12px;
  border-radius: 5px;
  font-size: 12px;
  max-height: 34px;
  min-height: 34px;
  height: 34px;
  cursor: pointer;
  /* max-height: 30px; */
}
#ddown1_second .btn-outline-secondary {
  background-color: initial !important;
  color: initial !important;
  border: none !important;
  border-color: initial !important;
  padding: 0px !important;
}
.new_cat_second {
  max-height: 34px;
  min-height: 34px;
  height: 34px;
  flex: 1;
  background: white;
  color: black;
  border: 1px solid;
  padding: 5px;
  border-radius: 5px;
  margin: 0 0px 0 12px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
}
.new_cat_second:hover {
  background: black;
  color: white;
}
.mange_category_second {
  display: flex;
  align-items: center;
  /* margin: 0 11px; */
}
.enable_sub_second {
  max-height: 34px;
  min-height: 34px;
  height: 34px;
  color: black;
  flex: 1;
  border: 1px solid gray;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
  /* max-height: 30px; */
}
@media screen and (max-width: 580px) {
  .de_tab.tab_style_2 .de_tab_content {
    padding: 20px;
  }
}
</style>
